export class ForecastError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
  ) {
    super(`Forecast request failed with status ${status}`);
    this.name = "ForecastError";
  }
}

let warnedAboutMissingBaseUrl = false;

/** Test helper — resets module warn latch (Phase 3 §0.E). */
export function __resetApiBaseUrlDevWarnFlag(): void {
  warnedAboutMissingBaseUrl = false;
}

/**
 * Returns the API base URL (see CF-2 in 06-build-plan).
 */
export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;

  if (raw !== undefined && String(raw).trim() !== "") {
    return String(raw).trim();
  }

  if (!warnedAboutMissingBaseUrl && import.meta.env.DEV && typeof console !== "undefined") {
    warnedAboutMissingBaseUrl = true;
    console.warn(
      "[tatterCast] VITE_API_BASE_URL is not set; falling back to same-origin requests. " +
        "Copy apps/web/.env.example to apps/web/.env.local to silence this in dev.",
    );
  }

  return typeof window !== "undefined" ? window.location.origin : "";
}
